import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'primereact/panel';
import { Gr8piFormattedDate } from '../../../../../components/Gr8piFormattedDateTime';
import SurveyProjectEmailButton from './SurveyProjectEmailButton';

const DataComponent = ({ surveyProject }) => {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <Panel header={surveyProject.name}>
          <div className="no-padding">
            <SurveyProjectEmailButton surveyProject={surveyProject} />
            <div className="details">
              <FormattedMessage id="super_survey.template_label" defaultMessage="Template" />:
              <span>{surveyProject.surveyTemplate.title}</span>
            </div>
            <div className="details">
              <FormattedMessage id="attrs.created.verbose" defaultMessage="Created on" />:
              <span>
                <Gr8piFormattedDate dateValue={surveyProject.createdOn} />
              </span>
            </div>
            <div className="details">
              <FormattedMessage id="attrs.updated.verbose" defaultMessage="Last update on" />:
              <span>
                <Gr8piFormattedDate dateValue={surveyProject.updatedOn} />
              </span>
            </div>
            <div className="details">
              <FormattedMessage id="attrs.created_by" defaultMessage="Created by" />:
              <span>
                {surveyProject.createdBy
                  ? `${surveyProject.createdBy.firstName} ${surveyProject.createdBy.lastName}`
                  : ''}
              </span>
            </div>
          </div>
        </Panel>
      </div>
    </div>
  );
};

DataComponent.propTypes = {
  surveyProject: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DataComponent;
